import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/styles/colors";
import { useNavigate } from "react-router-dom";
import { showGenericError } from "../../helper/Notifications";
import { isEmailValid } from "../../helper/ValidatorsHelper";
import CustomInput from "../Generic/CustomInput";
import PrimaryButton from "../Generic/PrimaryButton";
import { useUserContext } from "../../context/useUserContext";


const SendLinkcard = ({ setIsLoading }) => {
  const { resetPassword } = useUserContext

    ();
  const navigate = useNavigate();
  const initialValues = {
    email: "",
  };
  const [linkSent, setLinkSent] = useState(false);
  const [emailEditable, setEmailEditable] = useState(true);

  const [inputValues, setInputvalues] = useState(initialValues);
  const [emailValid, setEmailValid] = useState(true);
  const [sendLinkEnabled, setSendLinkEnable] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputvalues({
      ...inputValues,
      [name]: value,
    });
  };

  const handleSendLinkBtn = () => {
    if (!isEmailValid(inputValues.email)) {
      setEmailValid(false);
      // return;
    } else {
      setEmailValid(true);
    }

    if (isEmailValid(inputValues.email)) {
      setIsLoading(true);
      resetPassword(
        inputValues.email,
        () => {
          setIsLoading(false);
          setLinkSent(true);
          setEmailEditable(false);
        },
        () => {
          setIsLoading(false);
          showGenericError();
        }
      );
    }
  };

  const handleChangeEmailAddress = () => {
    setEmailEditable(true);
    setLinkSent(false);
  };

  const handleCreateAccountBtn = () => {
    navigate(`/register`);
  };

  useEffect(() => {
    if (inputValues.email.length > 0) {
      setSendLinkEnable(true);
    } else {
      setSendLinkEnable(false);
    }
  }, [inputValues]);

  return (
    <Card>
      <TitleContainer>
        <h1>{linkSent ? "Check your email" : "Reset password"}</h1>
        <Subtitle>
          {linkSent ? (
            <p>We have sent a password recover instructions to your email.</p>
          ) : (
            <p>
              Enter the email address associated with your account and we'll send you a link to reset your password.
            </p>
          )}
        </Subtitle>
      </TitleContainer>
      <InputsWrapper>
        <CustomInput
          readOnly={!emailEditable}
          label={linkSent ? "" : "Email"}
          placeholder="olivia@emotii.com"
          name={"email"}
          value={inputValues.email}
          onChange={handleInputChange}
          error={!emailValid}
          errorText={"Invalid email"}
        />
      </InputsWrapper>
      <SbmitWrapper>
        <PrimaryButton
          styled={{ width: "100%" }}
          disabled={!sendLinkEnabled}
          text={linkSent ? "Send Again" : "Send Link"}
          onClick={handleSendLinkBtn}
        />
        {linkSent && (
          <ChangeEmailLink onClick={handleChangeEmailAddress}>
            Change email address
          </ChangeEmailLink>
        )}
      </SbmitWrapper>
    </Card>
  );
};

export default SendLinkcard;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  padding: 50px;
  align-items: center;
  max-width: 530px;
  width: 100%;
  background: ${lightThemeColors.background};
  gap: 24px;
  border-radius: 10px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.08);

  @media(max-width:650px){
    width: 100%;
    padding: 30px 20px;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  text-align: center;

  h1 {
    color: ${lightThemeColors.darkColor};
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    margin: 0;
  }
`;
const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
`;

const ForgotPwd = styled.div`
  width: 100%;
  margin-top: -25px;
  p {
    width: fit-content;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: ${lightThemeColors.primaryColor};
    cursor: pointer;
  }
`;
const SbmitWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
`;

const ChangeEmailLink = styled.div`
  color: ${lightThemeColors.darkColor};
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${lightThemeColors.primaryColor};
  }
`;

const Subtitle = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;

  p {
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    text-align: center;
    margin: 0;
    max-width: 100%;
  }
`;
